<div class="_500 action-label field-value"
     [attr.data-hidden]="editMode"
     (click)="onCellClick(descriptor.zoneID)">
  <div class="file-container">
    <span [ngClass]="{'text-ellipsis': !!value?.file, 'w-md': !!value?.file}"
          [tooltip]="entityPath"
          [placement]="'right'"
          [innerHTML]="displayValue"
          [container]="'body'"></span>
    <ng-container *ngIf="value.file">
    <div class="file-actions" *ngIf="value.file">
      <i *ngIf="isViewAttachmentsActive() && isSupportedFileType(value.file.filename)"
        class="fa fa-light fa-eye pointer"
         [tooltip]="'TOOLTIPS.view' | translate"
         (click)="viewFile($event)">
      </i>
      <i class="fa fa-light fa-download pointer p-x-sm"
         [tooltip]="'EMPLOYEE_MANAGE.download' | translate"
         *ngIf="!downloading"
         (click)="downloadFile($event)">
      </i>
      <i *ngIf="downloading" class="fa fa-light fa-spinner fa-spin p-x-sm"></i>
    </div>
  </ng-container>
  </div>
</div>
<div [attr.data-hidden]="!editMode" class="editable-cell">
  <ng-template #fieldComponent></ng-template>
</div>
<gp-form-field-validation
  [control]="control"
  [descriptor]="descriptor"
  [groupZoneType]="groupZoneDescriptor.groupZoneType"
  [fieldData]="tableData"
>
</gp-form-field-validation>

<gp-view-document-side-panel
  *ngIf="showViewDocumentPanel"
  (close)="onCloseSidePanel()"
  [currentFileName]="currentFileName"
  [error]="previewError"
  [noSupportedFormat]="noSupportedFormat"
  [loading]="loadingPreview"
  [preview]="reportDefinitionPreview"
></gp-view-document-side-panel>
